import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Page } from './Page';
import { CSSProperties } from 'react';
import { CONSTANTS } from '../../assets/UIConstants';
import { Button } from 'material-ui';

const CONTACT_EMAIL: string = 'info@bodyknowledge.life';

@inject('store')
@observer
export class ContactUs extends Page<{}, {}> {
    public constructor(props: {}) {
        super(props);
        this.state = {};
    }

    public renderPage(): React.ReactNode {
        return (
            <div style={pageContainer}>
                <div style={contentArea}>
                    <div style={questionMark}>
                        ?
                    </div>
                    <div style={pageHeaderTitle}>
                        For questions or support, feel free to contact us at
                    </div>
                    <div style={pageHeaderSubTitle}>
                        {CONTACT_EMAIL}
                    </div>
                    <Button
                        style={contactUsButton}
                        size={'large'}
                        href={`mailto:${CONTACT_EMAIL}`}
                    >
                        CONTACT US!
                    </Button>
                </div>
            </div>
        );
    }
}

const pageContainer: CSSProperties = {
    flexGrow: CONSTANTS.FLEX_GROW.ONE,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};

const contentArea: CSSProperties = {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 120,
};
const pageHeaderTitle: CSSProperties = {
    fontSize: 28 + 'px',
    textAlign: 'center',
    color: 'black',
};
const pageHeaderSubTitle: CSSProperties = {
    textAlign: 'center',
    fontSize: 20 + 'px',
    marginTop: 30 + 'px',
    marginBottom: 40 + 'px',
    color: CONSTANTS.COLORS.SUB_TITLE_TEXT_GREY,
    fontWeight: 'bold',
};

const questionMark: CSSProperties = {
    backgroundColor: CONSTANTS.COLORS.TEXT_INPUT_BORDER,
    color: 'white',
    fontWeight: 'bold',
    fontSize: 25 + 'px',
    lineHeight: 60 + 'px',
    borderRadius: '50%',
    height: 60 + 'px',
    width: 60 + 'px',
    marginBottom: 30 + 'px',
};

const contactUsButton: CSSProperties = {
    borderRadius: 60 + 'px',
    height: 60 + 'px',
    paddingTop: 10 + 'px',
    paddingRight: 80 + 'px',
    paddingLeft: 80 + 'px',
    fontSize: 22 + 'px',
    fontWeight: 'bold',
    color: 'white',
    backgroundColor: CONSTANTS.COLORS.THEME_BLUE,
    border: 'none',
    boxShadow: CONSTANTS.BOX_SHADOW.LOGIN_BUTTONS,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/pages/ContactUs.tsx